// extracted by mini-css-extract-plugin
export var avatarBone = "_7-4";
export var buttonBone = "_7-3";
export var continueBone = "_7-a";
export var frame = "_7-1";
export var logoBone = "_7-2";
export var pickerGrid = "_7-d";
export var pitchBone = "_7-9";
export var productBone = "_7-8";
export var sectionBone = "_7-7";
export var shell = "_7-0";
export var skeletonPulse = "_7-b";
export var subtitleBone = "_7-6";
export var titleBone = "_7-5";
export var viewport = "_7-c";